// extracted by mini-css-extract-plugin
module.exports = {"container":"Header_container__3etP0","titleContainer":"Header_titleContainer__NmH2n","title":"Header_title__1Ao1p","actionContainer":"Header_actionContainer__2HI5X"};